import { useState } from "react";
import { MenuItem, Select, FormControl, InputLabel } from "@mui/material";
import noPicture from '../images/empty_image.png';

export default function DropdownWithImages({ items, onChange, preSelected }) {
  const [selected, setSelected] = useState(preSelected ? preSelected : "");

  const isValidImage = (url) => {
    return /\.(jpeg|jpg|png)$/i.test(url);
  };

  const handleChange = (event) => {
    const newValue = event.target.value;
    setSelected(newValue);
    if (onChange) {
      onChange(newValue);
    }
  };

  return (
    <FormControl fullWidth>
      <InputLabel id="dropdown-label">Select an Option</InputLabel>
      <Select
        labelId="dropdown-label"
        value={selected}
        onChange={handleChange}
      >
        {items && items.map((item) => (
          <MenuItem key={item.id} value={item.name}>
            <div className="flex items-center space-x-2">
              <img src={!item.avatar || !isValidImage(item.avatar)? noPicture : item.avatar} alt={item.name} className="w-6 h-6 rounded-full" style={{ width: 40, height: 40 }} />
              <span>{item.name}</span>
            </div>
          </MenuItem>
        ))}
      </Select>
    </FormControl>
  );
}
